import {
    Row,
    Col,
    Table,
    Button,
    Pagination,
    Form,
    Select,
    TreeSelect,
    Dropdown,
    Menu,
    message,
    Input,
    DatePicker
} from "antd";
import React, { useEffect, useState, useContext } from "react";
import Service from "./../../utils/apiOpen";
import IconVector from '../../assets/images/vector2.png';
import IconSearch from '../../assets/images/IconSearch.png';
import ICXem from '../../assets/images/Vector.png';
import IconExport from '../../assets/images/IconExport.png';
import Calendar from '../../assets/images/Calendar.png';
import Excel from './ExportFile';
import dayjs from "dayjs";
import helper from "./../../utils/helper";
import { exportTableToExcel } from "./../../components/common/export"
import { useNavigate } from 'react-router-dom';
import { LocalState } from "./index";

function ListOrder() {
    const { MessageSucces, config, goStep, detailOrder, setDetailOrder } = useContext(LocalState);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const formRef = React.createRef();
    const [formData, setFormData] = useState({ page: 1, pageSize: 10 });
    const [dataExport, setDataExport] = useState([]);
    const [total, setTotal] = useState(0);
    var [data, setData] = useState([]);
    const navigate = useNavigate();
    const { Option } = Select;

    useEffect(() => {
        form.setFieldsValue({
            fromDate: dayjs().startOf('month'),
            toDate: dayjs()
        });
        setFormData({
            ...formData,
            fromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
            toDate: dayjs().format('YYYY-MM-DD')
        });
    }, [config]);

    useEffect(() => {
        if (detailOrder?.productCodes) {
            form.setFieldsValue({
                productCodes: detailOrder?.productCodes.split(','),
                fromDate: detailOrder?.fromDate ? dayjs(detailOrder?.fromDate) : undefined,
                toDate:detailOrder?.toDate? dayjs(detailOrder?.toDate) : undefined
            });
            setFormData({
                ...formData,
                productCodes: detailOrder?.productCodes,
                fromDate: detailOrder?.fromDate || undefined,
                toDate: detailOrder?.toDate|| undefined,
            });
        }
    }, []);

    useEffect(() => {
        // if (!formData.productCodes) return;
        const timeoutId = setTimeout(() => {
            getList();
        }, 100);
        return () => clearTimeout(timeoutId);
    }, [formData]);

    const onFinish = (val) => {
        form
            .validateFields()
            .then(async (values) => {
                setFormData({
                    ...formData,
                    ...values,
                    phoneNumber: values?.phoneNumber || undefined,
                    fromDate: values.fromDate ? dayjs(values.fromDate).format('YYYY-MM-DD') : undefined,
                    toDate: values.toDate ? dayjs(values.toDate).format('YYYY-MM-DD') : undefined,
                    providerIds: values?.providerIds?.length > 0 ? values.providerIds.join(',') : undefined,
                    productCodes: values?.productCodes?.length > 0 ? values.productCodes.join(',') : undefined,
                    page: 1
                });
            })
            .catch((err) => { });
    };

    const getList = async () => {
        setLoading(true);
        const dataForm = {
            ...formData,
        }
        await Service.openApiCall("GET", `/v1/affiliate/portal/orders`, dataForm)
            .then((res) => {
                setLoading(false);
                let data = res?.data;
                if (data.success) {
                    setData(data?.data?.data);
                    setTotal(data?.data?.total);
                }
            })
            .catch((err) => {
                setLoading(false);
                setData([]);
                setTotal(0);
                if (err?.response) {
                    message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
                }
            });
    };

    const exportFile = async () => {
        setTimeout(() => {
            exportTableToExcel("export-orders", `danh_sach_don_hang.xlsx`);
        }, 1000);
    };

    const getDataExport = async (currentPage = 1, accumulatedData = []) => {
        setLoading(true);
        const dataForm = {
            ...formData,
            page: currentPage,
            pageSize: 100,
        };
        try {
            const res = await Service.openApiCall("GET", `/v1/affiliate/portal/orders/report`, dataForm);
            const data = res?.data;
            if (data?.success) {
                const newResults = data?.data?.data || [];
                const total = +data?.data?.total || 0;
                const updatedDataExport = [...accumulatedData, ...newResults];
                if (updatedDataExport.length >= total) {
                    setLoading(false);
                    if (updatedDataExport.length === 0) {
                        message.warning('Không có dữ liệu phú hợp.');
                        return;
                    };
                    message.success('Đang tải file. Vui lòng chờ trong giây lát!');
                    setDataExport(updatedDataExport);
                    exportFile(updatedDataExport);
                    return;
                }
                setTimeout(() => {
                    getDataExport(currentPage + 1, updatedDataExport);
                }, 500);
            } else {
                message.error("Lỗi khi lấy dữ liệu.");
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            if (err?.response) {
                message.error(err?.response?.data?.error?.statusCode + ' | ' + err?.response?.data?.message);
            } else {
                message.error("Lỗi không xác định.");
            }
        }
    };

    const columns = [
        {
            title: " ",
            render: (item, record, index) => (
                <div style={{ width: "30px", textAlign: "left" }}>
                    {index + 1 + (formData.page - 1) * formData.pageSize}
                </div>
            ),
        },
        {
            title: 'Mã đơn hàng',
            // align: 'center',
            render: (item, record, index) => (
                <div style={{ maxWidth: "130px" }}>
                    {item?.orderCode}
                </div>
            )
        },
        {
            title: 'Mã thành viên',
            render: (item, record, index) => (
                <div style={{ width: "130px" }}>
                    {item?.userCode}
                </div>
            )
        },
        {
            title: 'Thông tin người mua',
            render: (item, record, index) => (
                <div style={{ width: "130px", textAlign: "left", textTransform: 'capitalize' }}>
                    {item?.buyerName || "-"}
                </div>
            )
        },
        {
            title: 'Nhà bảo hiểm',
            render: (item, record, index) => (
                <div style={{ width: "130px" }}>
                    {item?.providerTitle}
                </div>
            )
        },
        {
            title: 'Sản phẩm',
            align: 'center',
            render: (item, record, index) => (
                <div style={{ minWidth: "150px", width: '100%', textAlign: 'center' }}>
                    {item?.productTitle}
                </div>
            )
        },
        {
            title: 'Phí bảo hiểm',
            align: 'center',
            render: (item, record, index) => (
                <div style={{ minWidth: "110px", width: '100%', textAlign: 'center' }}>
                    {helper.formatMoney(item?.fees)} đ
                </div>
            )
        },
        {
            title: 'Trạng thái',
            fixed: "right",
            align: 'center',
            render: (item, record, index) => (
                <div style={{ minWidth: "160px", display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                    {/* {RenderStatus(item?.statusId)} */}
                    <div style={{ width: 10, height: 10, backgroundColor: item?.statusColor, borderRadius: '50%', marginRight: 5, marginBottom: 2 }}>
                    </div>
                    <div style={{ color: item?.statusColor }}>{item?.statusTitle}</div>
                </div>
            )
        },
        {
            title: "",
            fixed: "right",
            align: "center",
            render: (item, record, index) => (
                <div style={{ width: "50px" }}>
                    <Dropdown
                        overlay={Action(item)}
                        trigger={["click"]}
                    >
                        <a className="ant-dropdown-link">
                            <img
                                src={IconVector}
                                style={{ width: 16 }}
                            />
                        </a>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const dropdownAction = [
        {
            title: "Xem chi tiết",
            avatar: (
                <img
                    src={ICXem}
                    style={{ width: 20 }}
                />
            )
        }
    ]

    const Action = (dataNote) => (
        <Menu
            shape="circle"
            className="custom-menu-dropdown"
        >
            {dropdownAction.map((value, index) => (
                <Menu.Item
                    key={index + 1}
                    icon={value.avatar}
                    onClick={(e) => {
                        switch (index) {
                            case 0:
                                navigate(`/order?orderCode=${dataNote?.orderCode}`);
                                setDetailOrder({ ...dataNote, fromDate: formData?.fromDate, toDate: formData?.toDate, productCodes: formData?.productCodes });
                                goStep(2);
                                break;
                            default:
                                break;
                        }
                    }}
                >
                    <div style={{ minWidth: 150 }}>{value.title}</div>
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <>
            {
                dataExport?.length > 0 &&
                <Excel data={dataExport} />
            }
            <div style={{ display: 'flex', alignItems: 'center', marginTop: 30, fontSize: 16, marginBottom: 30 }}>
                <div style={{ cursor: 'pointer' }} onClick={() => goStep(1)}>Quản lý đơn</div>
            </div>
            <div style={{ marginTop: 20 }}>
                <Form
                    ref={formRef}
                    layout={"vertical"}
                    scrollToFirstError
                    form={form}
                    onFinish={onFinish}
                    autoComplete="off"
                    initialValues={{
                        // fromDate: dayjs(),
                        // toDate: dayjs(),
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
                        <Row gutter={[10, 10]} style={{ width: '100%' }}>
                            <Col xs={8}>
                                <Row gutter={[10, 10]}>
                                    <Col xs={12}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span style={{ color: '#969696' }}>Từ</span>
                                            <Form.Item
                                                name={"fromDate"}
                                                style={{ margin: 0, width: "100%", marginLeft: 10 }}
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Vui lòng chọn thông tin",
                                                    },
                                                ]}
                                            >
                                                <DatePicker suffixIcon={<img src={Calendar} width={16} />} placeholder={'dd/mm/yyyy'} style={{ margin: 0, width: '100%' }} format='DD/MM/YYYY' />
                                            </Form.Item>
                                        </div>
                                    </Col>
                                    <Col xs={12}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span style={{ color: '#969696' }}>đến</span>
                                            <Form.Item
                                                name={"toDate"}
                                                style={{ margin: 0, width: "100%", marginLeft: 10 }}
                                                rules={[
                                                    {
                                                        required: false,
                                                        message: "Vui lòng chọn thông tin",
                                                    },
                                                ]}
                                            >
                                                <DatePicker suffixIcon={<img src={Calendar} width={16} />} placeholder={'dd/mm/yyyy'} style={{ margin: 0, width: '100%' }} format='DD/MM/YYYY' />
                                            </Form.Item>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={4}>
                                <Form.Item
                                    name={"productCodes"}
                                    style={{ margin: 0 }}
                                    rules={[
                                        {
                                            required: false,
                                            message: "",
                                        },
                                    ]}
                                >
                                    <TreeSelect
                                        dropdownMatchSelectWidth={false}
                                        allowClear
                                        multiple
                                        showSearch={true}
                                        treeCheckable={true}
                                        className="custom-Treeselect"
                                        popupClassName="custom-popup-treeselect"
                                        maxTagCount={'responsive'}
                                        filterTreeNode={(input, node) => {
                                            const normalize = str =>
                                                str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                                            return normalize(node?.title || '').includes(normalize(input));
                                        }}
                                        showArrow={true}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} sản phẩm`}
                                        placeholder={<span style={{ color: '#343A40' }}>Sản phẩm</span>}
                                    >
                                        {
                                            (config?.products || []).map((item) => (
                                                <TreeSelect.TreeNode key={item?.productCode} value={item?.productCode} title={item?.title} />
                                            ))
                                        }
                                    </TreeSelect>
                                </Form.Item>
                            </Col>
                            <Col xs={4}>
                                <Form.Item
                                    className="username"
                                    name={"providerIds"}
                                    style={{ margin: 0 }}
                                    rules={[
                                        {
                                            required: false,
                                            message: "Vui lòng chọn thông tin",
                                        },
                                    ]}
                                >
                                    <TreeSelect
                                        dropdownMatchSelectWidth={false}
                                        allowClear
                                        multiple
                                        showSearch={true}
                                        treeCheckable={true}
                                        className="custom-Treeselect"
                                        popupClassName="custom-popup-treeselect"
                                        maxTagCount={'responsive'}
                                        filterTreeNode={(input, node) => {
                                            const normalize = str =>
                                                str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                                            return normalize(node?.title || '').includes(normalize(input));
                                        }}
                                        showArrow={true}
                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} nhà BH`}
                                        placeholder={<span style={{ color: '#343A40' }}>Nhà bảo hiểm</span>}
                                    >
                                        {
                                            (config?.providers || []).map((item) => (
                                                <TreeSelect.TreeNode key={item?.id} value={item?.id} title={item?.title} />
                                            ))
                                        }
                                    </TreeSelect>
                                </Form.Item>

                            </Col>
                            <Col xs={4}>
                                <Form.Item
                                    className="username"
                                    name={"status"}
                                    style={{ margin: 0 }}
                                    rules={[
                                        {
                                            required: false,
                                            message: "Vui lòng chọn thông tin",
                                        },
                                    ]}
                                >
                                    <Select
                                        dropdownMatchSelectWidth={false}
                                        showSearch={true}
                                        allowClear={true}
                                        className="custom-select"
                                        style={{ textAlign: "left" }}
                                        filterOption={(input, node) => {
                                            const normalize = str =>
                                                str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                                            return normalize(node?.children || '').includes(normalize(input));
                                        }}
                                        placeholder={<span style={{ color: '#343A40' }}>Trạng thái</span>}
                                    >
                                        {
                                            (config?.status || []).map((item) => (
                                                <Option key={item?.code} value={item?.code} >{item?.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={4}>
                                <Form.Item
                                    style={{ margin: 0 }}
                                    name="phoneNumber"
                                    rules={[
                                        {
                                            required: false,
                                            message: "",
                                            min: 10,
                                            max: 10
                                        }
                                    ]}
                                >
                                    <Input
                                        className="custom-input"
                                        allowClear
                                        placeholder="Nhập SĐT thành viên..."
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Button
                            disabled={loading}
                            icon={
                                <img
                                    src={IconSearch}
                                    width="18"
                                    style={{ marginRight: 10 }}
                                />
                            }
                            htmlType="submit"
                            style={{
                                background: "#0B7CE4",
                                color: "#ffffff",
                                textAlign: "center",
                                borderRadius: 6,
                                border: "1px solid #0B7CE4",
                                height: 33,
                                alignItems: 'center', display: 'flex', marginLeft: 10
                            }}
                        >
                            Tìm kiếm
                        </Button>
                    </div>
                    <div style={{ display: "flex", justifyContent: 'space-between', marginTop: 15 }}>
                        <div style={{ fontSize: 20, color: '#003478' }}><b>Danh sách đơn hàng</b></div>
                        <Button
                            loading={loading}
                            onClick={() => getDataExport()}
                            icon={
                                <img
                                    src={IconExport}
                                    style={{
                                        width: "16px",
                                        objectFit: "contain",
                                        marginBottom: -4
                                    }}
                                />
                            }
                            style={{
                                background: "#f0f2f5",
                                boxShadow: 'none',
                                border: 'none',
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "8px 12px",
                                color: '#0b7ce4',
                                fontSize: 14
                            }}
                        >
                            Xuất báo cáo
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="tabled" style={{ marginTop: 20 }}>
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Table
                            loading={loading}
                            dataSource={data} columns={columns}
                            pagination={false}
                            className="ant-border-space table-custom"
                            rowClassName={() => "rowClassName1"}
                            bordered={false}
                            scroll={{ x: "auto" }}
                            showHeader={true}
                        />
                        <div style={{ display: 'flex', margin: "10px", alignItems: 'center', justifyContent: 'center' }}>
                            <Pagination
                                total={total || 10}
                                pageSize={formData?.pageSize}
                                onChange={(e) => {
                                    setFormData({ ...formData, page: e })
                                }}
                                showSizeChanger={false}
                                current={formData?.page}
                                size="small"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default ListOrder;
